import React from 'react';
export var LabelsPortalContext = React.createContext(null);
